//const api: string|undefined= process.env.REACT_APP_API;

import Api from "../../utils/api";
import { API_URLS } from "../../utils/api.urls";

export const resetPassword = async (params: any | null): Promise<any> => {
  const data = await Api.post(API_URLS.RESET_PASSWORD, params);
  return data;
};
